import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import Cookies from 'js-cookie';
// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from './actionTypes';
import { apiError, loginSuccess, logoutUserSuccess } from './actions';

import { postLogin, postSocialLogin } from '../../../helpers/backend_helper';
import { notifyError } from '../../../components/notify';
import axios from 'axios';

function* loginUser({ payload: { user, history, rememberMe } }) {
  try {
    const response = yield call(postLogin, {
      username: user.username,
      password: user.password,
    });

    sessionStorage.setItem('authUser', JSON.stringify(response));

    if (rememberMe) {
      Cookies.set('remenberUser', user.username);
    } else {
      Cookies.remove('remenberUser');
    }
    yield put(loginSuccess(response));

    axios.defaults.headers.common['Authorization'] = response
      ? response.data.token
      : null;

    history.push('/overview');
  } catch (error) {
    yield put(apiError(error));
    notifyError(error.response.data.message);
  }
}

function* logoutUser() {
  try {
    sessionStorage.removeItem('authUser');
    yield put(logoutUserSuccess(LOGOUT_USER, true));
    sessionStorage.removeItem('@prosmed:office');
    sessionStorage.removeItem('organizationInput');
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    const response = yield call(postSocialLogin, data);
    sessionStorage.setItem('authUser', JSON.stringify(response));
    yield put(loginSuccess(response));
    history.push('/overview');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
